import {QRcode} from "./components/QRcode"
function App() {
  return (
    <>
     <QRcode/>
    </>
  );
}

export default App;
